import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DenyExpensePresenter`

export default defineMessages({
  denySuccess: {
    id: `${scope}.denySuccess`,
    defaultMessage: 'Expense report #{expenseId} denied',
  },
  denyError: {
    id: `${scope}.denyError`,
    defaultMessage: "Expense report couldn't be denied",
  },
})
